import React, { useMemo, useState } from "react";
import { useAuth } from "../context/AuthContext";

export default function ChangePasswordPage() {
  const { user } = useAuth();
  const [currentPassword, setCurrentPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [newPassword2, setNewPassword2] = useState("");
  const [saving, setSaving] = useState(false);
  const [ok, setOk] = useState("");
  const [error, setError] = useState("");

  const canSubmit = useMemo(() => {
    if (!currentPassword || !newPassword || !newPassword2) return false;
    if (newPassword !== newPassword2) return false;
    if (newPassword.length < 8) return false;
    return true;
  }, [currentPassword, newPassword, newPassword2]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setOk("");
    setError("");

    if (!currentPassword || !newPassword || !newPassword2) {
      setError("Vyplň prosím všechna pole.");
      return;
    }

    if (newPassword !== newPassword2) {
      setError("Nová hesla se neshodují.");
      return;
    }

    if (newPassword.length < 8) {
      setError("Nové heslo musí mít alespoň 8 znaků.");
      return;
    }

    setSaving(true);
    try {
      const res = await fetch("/api/auth/change-password", {
        method: "POST",
        credentials: "include",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          currentPassword,
          newPassword,
        }),
      });

      const j = await res.json().catch(() => ({}));

      if (!res.ok) {
        throw new Error(j?.message || "Změna hesla se nezdařila.");
      }

      setOk(j?.message || "Heslo bylo změněno.");
      setCurrentPassword("");
      setNewPassword("");
      setNewPassword2("");
    } catch (err) {
      setError(err?.message || "Změna hesla se nezdařila.");
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="max-w-xl mx-auto p-6">
      <h1 className="text-2xl font-bold text-blue-900 mb-2">Změna hesla</h1>

      <div className="text-sm text-gray-600 mb-6">
        Přihlášen: <span className="font-medium">{user?.username}</span>
      </div>

      {error && (
        <div className="mb-4 p-3 rounded bg-red-50 text-red-700 border border-red-100">
          {error}
        </div>
      )}

      {ok && (
        <div className="mb-4 p-3 rounded bg-green-50 text-green-700 border border-green-100">
          {ok}
        </div>
      )}

      <form onSubmit={handleSubmit} className="space-y-4">
        <div>
          <label className="block text-sm text-gray-700 mb-1">
            Aktuální heslo
          </label>
          <input
            type="password"
            className="w-full border rounded px-3 py-2"
            value={currentPassword}
            onChange={(e) => setCurrentPassword(e.target.value)}
            autoComplete="current-password"
          />
        </div>

        <div>
          <label className="block text-sm text-gray-700 mb-1">Nové heslo</label>
          <input
            type="password"
            className="w-full border rounded px-3 py-2"
            value={newPassword}
            onChange={(e) => setNewPassword(e.target.value)}
            autoComplete="new-password"
          />
          <div className="text-xs text-gray-500 mt-1">Minimálně 8 znaků.</div>
        </div>

        <div>
          <label className="block text-sm text-gray-700 mb-1">
            Nové heslo znovu
          </label>
          <input
            type="password"
            className="w-full border rounded px-3 py-2"
            value={newPassword2}
            onChange={(e) => setNewPassword2(e.target.value)}
            autoComplete="new-password"
          />
        </div>

        <button
          type="submit"
          disabled={!canSubmit || saving}
          className="w-full bg-blue-600 text-white rounded px-4 py-2 hover:bg-blue-700 disabled:opacity-60"
        >
          {saving ? "Ukládám…" : "Změnit heslo"}
        </button>
      </form>

      <div className="mt-6 text-xs text-gray-500">
        Pokud jsi heslo zapomněl, použij stránku „Zapomenuté heslo“ na přihlašovací obrazovce.
      </div>
    </div>
  );
}